import { useTheme } from "app/theme-context";
import * as React from "react";

export const Footer = () => {
    const { cssProperties } = useTheme();

    return (
        <footer className="footer" style={cssProperties}>
            <div className="footer-container">
                <span className="mr-3">
                    Linked Data Viewer{" "}
                    {build_info.buildVersion} - powered by
                    <a className="company-logo mx-1" href="https://laceshub.com" target="_blank">
                        Laces
                    </a>
                    Copyright (c)
                    <a className="company-logo ml-1" href="https://semmtech.com/" target="_blank">
                        <span className="copyright-sign-image">
                            <span className="company-logo-img">Semmtech B.V.</span>
                        </span>
                    </a>
                </span>
            </div>
        </footer>
    );
};
